var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document",attrs:{"id":"appRoot"}},[_c('Header'),_c('keep-alive',[_c('router-view')],1),_c('Footer'),_c('transition',{attrs:{"name":"toast"}},[(_vm.toast)?_c('div',{staticClass:"toast"},[_c('div',{staticClass:"toast-inner"},[_vm._v(_vm._s(_vm.toast))])]):_vm._e()]),_c('button',{staticClass:"page-scroll-top",class:{
      'down': _vm.percent <= 0
    },attrs:{"type":"button"},on:{"click":_vm.onScrollTop}},[_c('arrow-up')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }